import React, { useRef } from 'react'
import SlidingPane from "react-sliding-pane";
import Tooltip from "@tippyjs/react";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { getTrans as t } from "../../../Localization/translations";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const AddAsset = ({state3,setState3,isEquipment,handleSubmit5,handlePartyAsset,form5,asset_number,register5,setAsset_number,make,setMake,model,setModel,
  manufacturer,setManufacturer,residal_value,setResidal_value,in_service_date,setIn_service_date,checkBtn5,handlevin,vin_number,setVin_number,year,setYear,
  milage,setMilage,quantity,quantityError,handleQuantityChange,serialRows,handleSerialNumberChange,
}) => {
  return (<SlidingPane
        className="some-custom-class sidepanebar"
        isOpen={state3.isPaneOpen}
        title="Add Asset"
        subtitle=""
        onRequestClose={() => {
          setState3({ isPaneOpen: false });
        }}
      >
        {isEquipment ?
          <Form
            role='form text-left'
            onSubmit={handleSubmit5(handlePartyAsset)}
            ref={form5}
            key={5}
            action="."
            method="POST"
            id="addAssetForm"
          >
            {
              <>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label className="col-form-label">
                      {t("Asset Number")}{" "}
                      <Tooltip content={t("Assetnumber_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        className="form-control"
                        type="text"
                        name="asset_number"
                        maxLength="200"
                        disabled
                        value={asset_number}
                        {...register5("asset_number", {
                          onChange: (e) => {
                            setAsset_number(e.target.value);
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label">
                      {t("Quantity")}{" "}
                      <Tooltip content={t("Quantity_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      value={quantity}
                      onChange={handleQuantityChange}
                      type="number"
                      min="1"
                      name="quantity"
                      id="quantity"
                      className="form-control"
                    />
                    {quantityError && (
                      <div className="invalid-feedback">{quantityError}</div>
                    )}
                  </div>
                  <div className="form-group row">
                  <div className="col-lg-6">
                    <div className="table-responsive">
                      <table className="table table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>
                              {t("Serial Number")}{" "}
                              <Tooltip content={t("SerialNumber_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {serialRows.map((row, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  value={row.serial_number}
                                  onChange={(e) =>
                                    handleSerialNumberChange(index, e.target.value)
                                  }
                                  type="text"
                                  className="form-control"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  </div>
                  <div className="form-group row">
                    {/* <div className="col-md-6">
                              <label className="col-form-label">
                                {t("License No")}{" "}
                                <Tooltip content={t("vinnumber_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("License No")}
                                className="form-control"
                                type="text"
                                name="license_number"
                                maxLength="200"
                                id="id_license_number"
                                value={license_number}
                                onChange={(e) => setLicense_number(e.target.value)}
                             
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="col-form-label">
                                {t("License State")}{" "}
                                <Tooltip content={t("year_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("License State")}
                                className="form-control"
                                type="text"
                                name="license_state"
                                id="id_license_state"
                                value={license_state}
                                {...register5("license_state", {
                                  onChange: (e) => {
                                    setLicense_state(e.target.value);
                                  },
                                })}
                              />
                            </div> */}
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Make")}{" "}
                        <Tooltip content={t("Make_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Make")}
                        className="form-control"
                        type="text"
                        name="make"
                        maxLength="30"
                        id="id_make"
                        value={make}
                        {...register5("make", {
                          onChange: (e) => {
                            setMake(e.target.value);
                          },
                          // required: true,
                        })}
                      />
                      {/* <div className="invalid-feedback">
                              {errors4.make?.type === "required" &&
                                "Make is required"}
                            </div> */}
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Model")}{" "}
                        <Tooltip content={t("Model_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Model")}
                        className="form-control"
                        type="text"
                        name="model"
                        maxLength="100"
                        id="id_model"
                        value={model}
                        {...register5("model", {
                          onChange: (e) => {
                            setModel(e.target.value);
                          },
                          // required: true,
                        })}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <label className="col-form-label">
                        {t("Manufacturer")}{" "}
                        <Tooltip content={t("Manufacturer_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Manufacturer")}
                        className="form-control"
                        type="text"
                        name="manufacturer"
                        // maxLength="200"
                        // id="manufacturer"
                        value={manufacturer}
                        onChange={(e) => setManufacturer(e.target.value)}
                      // {...register5("manufacturer", {
                      //   onChange: (e) => {
                      //     setManufacturer(e.target.value);
                      //   },
                      // })}
                      />
                      {/* <div className="invalid-feedback">
                   {errors4.year?.type === "required" &&
                     "Year is required"}
                 </div> */}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Residual Value")}{" "}
                        <Tooltip content={t("Residualvalue_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Residual Value")}
                        className="form-control"
                        type="text"
                        name="residulevalue"
                        maxLength="30"
                        id="id_residual_Value"
                        value={residal_value}
                        {...register5("residulevalue", {
                          onChange: (e) => {
                            setResidal_value(e.target.value);
                          },
                          // required: true,
                        })}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("In Service Date")}{" "}
                        <Tooltip content={t("in_service_date_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <DatePicker
                        className="form-control datepick"
                        selected={in_service_date}
                        onChange={(e) => setIn_service_date(e)}
                        placeholderText={"mm/dd/yyyy"}
                        showYearDropdown // year show and scrolldown alos
                        scrollableYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="border-0 btn btn-primary btn-gradient-primary btn-md"
                >
                  {t("Save")}
                </button>
                &nbsp;&nbsp;
              </>
            }
            <CheckButton style={{ display: "none" }} ref={checkBtn5} />

          </Form>
          :
          <Form
            role='form text-left'
            onSubmit={handleSubmit5(handlePartyAsset)}
            ref={form5}
            key={5}
            action="."
            method="POST"
            id="addAssetForm"
          >
            {
              <>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label className="col-form-label">
                      {t("Asset Number")}{" "}
                      <Tooltip content={t("Assetnumber_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        className="form-control"
                        type="text"
                        name="asset_number"
                        maxLength="200"
                        disabled
                        value={asset_number}
                        {...register5("asset_number", {
                          onChange: (e) => {
                            setAsset_number(e.target.value);
                          },
                          // required: true,
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label">
                      {t("Quantity")}{" "}
                      <Tooltip content={t("Quantity_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      value={quantity}
                      onChange={handleQuantityChange}
                      type="number"
                      min="1"
                      name="quantity"
                      id="quantity"
                      className="form-control"
                    />
                    {quantityError && (
                      <div className="invalid-feedback">{quantityError}</div>
                    )}
                  </div>
                  <div className="form-group row">
                  <div className="col-lg-6">
                    <div className="table-responsive">
                      <table className="table table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>
                              {t("Serial Number")}{" "}
                              <Tooltip content={t("SerialNumber_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {serialRows.map((row, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  value={row.serial_number}
                                  onChange={(e) =>
                                    handleSerialNumberChange(index, e.target.value)
                                  }
                                  type="text"
                                  className="form-control"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6" style={{ display: "none" }}>
                      <label className="col-form-label">
                        {t("VIN Number")}{" "}
                        <Tooltip content={t("vinnumber_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("VIN Number")}
                        className="form-control"
                        type="text"
                        name="vin_number"
                        onBlur={handlevin}
                        maxLength="200"
                        id="id_vin_number"
                        value={vin_number}
                        onChange={(e) => setVin_number(e.target.value)}
                      // {...register5("vin_number", {
                      //   onBlur: handlevin,
                      // })}
                      />
                      {/* <div className="invalid-feedback">
                              {errors4.vin_number?.type === "required" &&
                                "Vin Number is required"}
                            </div> */}
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Year")}{" "}
                        <Tooltip content={t("year_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Year")}
                        className="form-control"
                        type="text"
                        name="year"
                        maxLength="200"
                        id="id_year"
                        value={year}
                        {...register5("year", {
                          onChange: (e) => {
                            setYear(e.target.value);
                          },
                        })}
                      />
                      {/* <div className="invalid-feedback">
                              {errors4.year?.type === "required" &&
                                "Year is required"}
                            </div> */}
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Manufacturer")}{" "}
                        <Tooltip content={t("Manufacturer_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Manufacturer")}
                        className="form-control"
                        type="text"
                        name="manufacturer"
                        // maxLength="200"
                        // id="manufacturer"
                        value={manufacturer}
                        onChange={(e) => setManufacturer(e.target.value)}
                      // {...register5("manufacturer", {
                      //   onChange: (e) => {
                      //     setManufacturer(e.target.value);
                      //   },
                      // })}
                      />
                      {/* <div className="invalid-feedback">
                              {errors4.year?.type === "required" &&
                                "Year is required"}
                            </div> */}
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Make")}{" "}
                        <Tooltip content={t("Make_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Make")}
                        className="form-control"
                        type="text"
                        name="make"
                        maxLength="30"
                        id="id_make"
                        value={make}
                        {...register5("make", {
                          onChange: (e) => {
                            setMake(e.target.value);
                          },
                          // required: true,
                        })}
                      />
                      {/* <div className="invalid-feedback">
                              {errors4.make?.type === "required" &&
                                "Make is required"}
                            </div> */}
                    </div>

                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Model")}{" "}
                        <Tooltip content={t("Model_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Model")}
                        className="form-control"
                        type="text"
                        name="model"
                        maxLength="100"
                        id="id_model"
                        value={model}
                        {...register5("model", {
                          onChange: (e) => {
                            setModel(e.target.value);
                          },
                          // required: true,
                        })}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Residual Value")}{" "}
                        <Tooltip content={t("Residualvalue_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Residual Value")}
                        className="form-control"
                        type="text"
                        name="residulevalue"
                        maxLength="30"
                        id="id_residual_Value"
                        value={residal_value}
                        onChange={(e) => setResidal_value(e.target.value)}
                      />
                    </div>

                  </div>
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("In Service Date")}{" "}
                        <Tooltip content={t("in_service_date_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <DatePicker
                        className="form-control datepick"
                        selected={in_service_date}
                        onChange={(e) => setIn_service_date(e)}
                        placeholderText={"mm/dd/yyyy"}
                        showYearDropdown // year show and scrolldown alos
                        scrollableYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                      />
                      {/* <div className="invalid-feedback">
                              {errors4.in_service_date?.type === "required" &&
                                "In Service Date is required"}
                            </div> */}
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Mileage")}{" "}
                        <Tooltip content={t("Mileage_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Mileage")}
                        className="form-control"
                        type="text"
                        name="mileage"
                        maxLength="30"
                        id="id_mileage"
                        value={milage}
                        {...register5("mileage", {
                          onChange: (e) => {
                            setMilage(e.target.value);
                          },
                          // required: true,
                        })}
                      />
                      {/* <div className="invalid-feedback">
                              {errors4.mileage?.type === "required" &&
                                "Mileage is required"}
                            </div> */}
                    </div>

                  </div>
                </div>
                <button
                  type="submit"
                  className="border-0 btn btn-primary btn-gradient-primary btn-md"
                >
                  {t("Save")}
                </button>
                &nbsp;&nbsp;
              </>
            }
            <CheckButton style={{ display: "none" }} ref={checkBtn5} />

          </Form>

        }
      </SlidingPane>
  )
}

export default AddAsset